// app/src/lib/localCache.js — Dexie (IndexedDB) read-cache for offline viewing.
//
// Crew is server-authoritative: this cache is NOT the source of truth. It only
// stores the last-seen workplaces and board posts so already-loaded content is
// viewable offline. Writes always go to the API first (see api.js); the cache is
// refreshed from API responses.

import Dexie from 'dexie';

export const db = new Dexie('crew-cache');

db.version(1).stores({
  // Mirrors of server data, keyed for quick local reads. `wid` = workplaceId.
  workplaces: 'workplaceId',
  members: '[workplaceId+userId], workplaceId',
  posts: '[workplaceId+postId], workplaceId, createdAt',
});

/** Replace the cached posts for a workplace with a fresh server page. */
export async function cachePosts(workplaceId, posts) {
  await db.transaction('rw', db.posts, async () => {
    await db.posts.where('workplaceId').equals(workplaceId).delete();
    if (posts && posts.length) {
      await db.posts.bulkPut(posts.map((p) => ({ ...p, workplaceId })));
    }
  });
}

/** Read cached posts for a workplace (newest first). */
export async function cachedPosts(workplaceId) {
  return db.posts.where('workplaceId').equals(workplaceId).reverse().sortBy('createdAt');
}

export async function resetCache() {
  await db.delete();
}
